import { FC } from "react";

export interface Props {
  position?: number;
}

const QueuePosition: FC<Props> = ({ position = 0 }) => {
  if (position <= 0) return null;

  return (
    <div className="system-msg-container">
      <span className="system-msg">Queue position: {position}</span>
    </div>
  );
}

export default QueuePosition;
